/** Pure classifier for a pre-booking screening refusal (S8, ClickUp 86d439wvy). */

export type ScreeningOutcome = "ok" | "contraindicated" | "incomplete" | "error";

const CONTRAINDICATED = "screening_contraindicated";
const INCOMPLETE = "screening_incomplete";

/** The 422 code the BOOKING call answers when a held pass expired mid-session. */
export const SCREENING_REQUIRED = "screening_required";

/** `"ok"` means "not a screening refusal" — a 500 or a network drop keeps the caller's ordinary handling. */
export const classifyScreeningError = (status?: number, code?: string): ScreeningOutcome => {
	if (status !== 422) return "ok";

	if (code === CONTRAINDICATED) return "contraindicated";
	if (code === INCOMPLETE) return "incomplete";

	// Never guess "contraindicated": a terminal screen on a recoverable refusal strands a bookable patient.
	return "error";
};
